if( !Array.prototype.offset ) Array.prototype.offset = function ( offset = 0 )
{
    var self = this

    if( offset === 0 ) return self

    var _ret = []

    if( offset )
    {
        for( var i = 0; i < self.length; i++ )
        {
            if( (i + 1) > offset )
            {
                _ret.push( self[ i ] )
            }
        }
    }

    return _ret
}

module.exports = {}